export default __webpack_public_path__ + "static/media/discord.3876acf1.svg";